<template lang="pug">
  v-card.overflow-hidden
    v-card-content
      h2.card-title {{ 'perm.report.planfeed' | translate }}
    .cols-x
      .cols-x__2
        p.ml-4 {{ 'base.loadings_by_ingredients' | translate }}:
        table.table
          thead
            tr.table__row.table__row--head
              th.table__cell {{ 'base.ingredients' | translate }}
              th.table__cell.text-right {{ 'base.loading_weight' | translate }} [{{ 'base.kg' | translate }}]
              th.table__cell.text-right {{ 'base.loading_process' | translate }} [{{ 'base.kg' | translate }}]
          tbody
            tr.table__row(
              v-for="(item, index) in ingredients"
              :key="item.id")
              td.table__cell {{ item.name }}
              td.table__cell.text-right {{ Math.round(item.plan_weight) }}
              td.table__cell.text-right {{ Math.round(next_weight.ingredients[index]) }}
            tr.table__row
              td.table__cell.bg-gray {{ 'base.total' | translate }}:
              td.table__cell.bg-gray.text-right {{ Math.round(next_weight.ingredients[next_weight.ingredients.length - 1]) }}
              td.table__cell.bg-gray.text-right {{ Math.round(next_weight.ingredients[next_weight.ingredients.length - 1]) }}
      .cols-x__2
        p.ml-4 {{ 'base.uploadings_by_groups' | translate }}:
        table.table
          thead
            tr.table__row.table__row--head
              th.table__cell {{ 'base.groups' | translate }}
              th.table__cell.text-right {{ 'base.loading_weight' | translate }} [{{ 'base.kg' | translate }}]
              th.table__cell.text-right {{ 'base.loading_process' | translate }} [{{ 'base.kg' | translate }}]
          tbody
            tr.table__row(
              v-for="(item, index) in groups"
              :key="item.id")
              td.table__cell {{ item.name }}
              td.table__cell.text-right {{ Math.round(item.plan_weight) }}
              td.table__cell.text-right {{ Math.round(next_weight.groups[index]) }}
            tr.table__row
              td.table__cell.bg-gray {{ 'base.total' | translate }}:
              td.table__cell.bg-gray.text-right {{ Math.round(next_weight.groups[next_weight.groups.length - 1]) }}
              td.table__cell.bg-gray.text-right {{ Math.round(next_weight.groups[next_weight.groups.length - 1]) }}
</template>

<script>
import { timeString } from '@/util'

export default {
  name: 'PlanfeedDetail',

  props: {
    selected: Object
  },

  data: () => ({
    next_weight: {
      ingredients: [],
      groups: []
    }
  }),

  mounted () {
    this.calculateNextWeight()
  },

  methods: {
    formateTimeString (str) {
      return timeString(str)
    },

    calculateNextWeight () {
      for (let i = 0; i < this.ingredients.length; i++) {
        if (i > 0) {
          this.next_weight.ingredients.push(this.ingredients[i].plan_weight + this.next_weight.ingredients[i - 1])
        } else {
          this.next_weight.ingredients.push(this.ingredients[i].plan_weight)
        }
      }
      for (let i = 0; i < this.groups.length; i++) {
        if (i > 0) {
          this.next_weight.groups.push(this.groups[i].plan_weight + this.next_weight.groups[i - 1])
        } else {
          this.next_weight.groups.push(this.groups[i].plan_weight)
        }
      }
    }
  },

  computed: {
    ingredients () {
      if (this.selected) {
        return this.selected.schedule_ration.ingredients
      }
      return []
    },

    groups () {
      if (this.selected) {
        return this.selected.schedule_groups
      }
      return []
    }
  }
}
</script>
